<template>
  <div class="home">
  </div>
</template>
<script>
  export default {
    data() {
      return {
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// Home.vue?9d3da448